import { type FC, type HTMLAttributes } from 'react';
import { BoostButton } from '@components/ui/BoostButton/BoostButtton';
import {
  factoryFreeBoostAvailable,
  getMaxExpiresTimeForFactoryBoosts,
} from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

interface BoostFactoryButtonProps extends HTMLAttributes<HTMLButtonElement> {
  plantId: string;
  totalBoost: number;
}

const BoostFactoryButton: FC<BoostFactoryButtonProps> = ({
  plantId,
  totalBoost,
  ...props
}) => {
  const time = useAppSelector((state) =>
    getMaxExpiresTimeForFactoryBoosts(state, plantId),
  );
  const isFreeBoostAvailable = useAppSelector(factoryFreeBoostAvailable);

  return (
    <BoostButton
      isFreeBoostAvailable={isFreeBoostAvailable}
      value={totalBoost}
      {...props}
      className={props.className}
      {...time}
    ></BoostButton>
  );
};

export { BoostFactoryButton };
